import { useEffect } from 'react';
import { useAppDispatch } from '../../redux/hooks';
import { useNavigate } from 'react-router-dom';
import {
  auth_check,
  super_admin as superAdminFunc,
} from '../../redux/action/auth.action';
import PreLoader from '@lift-admin/ui/pre-loader';

export default function PrivateRoute({ children }: { children: any }) {
  const auth = JSON.parse(localStorage.getItem('admin_auth') as string);

  const dispatch = useAppDispatch();
  // const { admin_auth } = useSelector((state:any) => state.admin);
  const navigate = useNavigate();
  useEffect(() => {
    // console.log("admin", superAdmin);

    sessionStorage.setItem('register', '1');
    dispatch(superAdminFunc(true));
    // dispatch(auth_check(auth));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children;
}
